import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getTagInfoforSupplier, getUserProfile } from "../services/api";
import { useSearchParams, useNavigate } from "react-router-dom";
import { convertFromISO } from "../utils/dateValidation";
import { PlusSquare } from "lucide-react";
import Cookies from "js-cookie";
import {
    Box,
    Grid,
    Container,
    TextField,
    Typography,
    useMediaQuery,
    Alert,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import { set } from "lodash";

const CheckSupplierPage = () => {
    const [searchParams] = useSearchParams();
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const orderId = searchParams.get('qr') || '';
    const [qrImagePreview, setqrImagePreview] = useState(null);
    const { t } = useTranslation();
    const [petImagePreview, setPetImagePreview] = useState(null);
    const isMobile = useMediaQuery("(max-width:850px)");
    const navigate = useNavigate();
    const [tagInfo, setTagInfo] = useState({
        staffVerification: "",
        contact: "",
        verifyDate: "",
        petName: "",
        shortUrl: "",
        masterEmail: "",
        qrUrl: "",
        petUrl: "",
        orderId: "",
        location: "",
        petHuman: "",
        createdAt: "",
        tagId: "",
        pendingStatus: "",
        option: "",
        optionSize: "",
        optionColor: "",
    });

    // Create a preview URL for the image
    const reader = new FileReader();
    reader.onloadend = () => {
        setqrImagePreview(reader.result);
    };

    // Create a preview URL for the image
    const reader2 = new FileReader();
    reader2.onloadend = () => {
        setPetImagePreview(reader.result);
    };

    // Fetch supplier data if editing
    useEffect(() => {
        setLoading(true);
        if (!orderId) {
            setError("No Information found!");
            setLoading(false);
        }
        getTagInfoforSupplier(orderId)
            .then((response) => {
                const tagData = response.data.form;
                setTagInfo((prev) => ({
                    ...prev,
                    ...tagData,
                    createdAt: convertFromISO(tagData.createdAt),
                }));
                if (tagData.petUrl) {
                    setPetImagePreview(tagData.petUrl);
                }
                if (tagData.qrUrl) {
                    setqrImagePreview(tagData.qrUrl);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching Tag Info:", error);
            });
    }, [orderId]);

    console.log("Tag Info:", tagInfo);

    if (loading) {
        return (
            <Box
                sx={{
                    bgcolor: "#fcf8f3",
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h6" color="text.secondary">
                        {/* 載入中... */}
                        <img src="https://petpetclub.s3.ap-southeast-1.amazonaws.com/user-uploads/pets/68cb893a0feda12f2dbcc02b/68d4c8ce22baedfbe8b852dd.gif" alt=""
                            style={{
                                width: '150px',
                                height: 'auto',
                                mixBlendMode: 'multiply',
                            }} />
                        <div
                            style={{
                                fontWeight: "500px",
                                fontSize: "15px",
                                textAlign: "center",
                                fontFamily: "Lucida Console",

                            }}>
                            {t('Loading')}
                        </div>
                    </Typography>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ bgcolor: "#fcf8f3", minHeight: "100vh" }}>
            {/* Header */}
            <Navbar />

            {/* Main Content */}
            <Container
                maxWidth="lg"
                sx={{
                    py: { xs: 4, md: 8 },
                    px: { xs: 2, md: 3 },
                    mt: "70px", // Add top margin to account for fixed navbar height
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        mb: { xs: 3, md: 5 },
                        fontWeight: "bold",
                        fontSize: { xs: "24px", sm: "28px", md: "32px" },
                    }}
                >
                    Supplier Information Page \ 供應商資訊
                </Typography>

                {/* Error and Success Messages */}
                {error && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                        {error}
                        <Button
                            style={{
                                backgroundColor: "var(--color-button-primary)",
                                color: "var(--color-black)",
                                fontWeight: "bold",
                                fontSize: 10,
                                padding: "2px 8px",
                                marginLeft: "5px",
                                minWidth: 0,
                            }}
                            onClick={() => navigate(`/supplier`)}
                        >
                            Input
                        </Button>
                    </Alert>
                )}

                <Grid container justifyContent="space-between" sx={{ px: 3, gap: '20px' }} >
                    <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: '20px', width: isMobile ? "100%" : "40%" }}>
                        {/* Pet Name */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Pet Name \ 寵物名:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder=""
                                value={tagInfo.petName}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Pet Contact */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Phone Number \ 聯絡電話:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder=""
                                value={tagInfo.contact}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>
                        {/* Pet Short Url */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Pet Short Url \ 短網址 :
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                value={tagInfo.shortUrl}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Order Number */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Order Number \ 單號:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.orderId}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>



                        {/* Tag Id */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Tag Id \ 牌號碼:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.tagId}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Size \ 尺寸:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.optionSize + ' mm'}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Color \ 顏色:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.optionColor}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                    </Grid>
                    <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: '20px', width: isMobile ? "100%" : "40%" }}>
                        {/* Pet Tag Image */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Pet Tag Image \ 二維碼:
                            </Typography>
                            <Box
                                sx={{
                                    border: 1,
                                    borderColor: "grey.300",
                                    borderRadius: 1,
                                    p: 4,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: 350,
                                    backgroundColor: "white",
                                    position: "relative",
                                }}
                            >
                                {qrImagePreview ? (
                                    <img
                                        src={qrImagePreview}
                                        alt="預覽圖片"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: 250,
                                            marginBottom: 16,
                                            borderRadius: 8,
                                        }}
                                    />
                                ) : (
                                    <PlusSquare size={48} />
                                )}
                            </Box>
                        </Box>

                        {/* Pet Image */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Pet Image \ 寵物照:
                            </Typography>
                            <Box
                                sx={{
                                    border: 1,
                                    borderColor: "grey.300",
                                    borderRadius: 1,
                                    p: 4,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: 350,
                                    backgroundColor: "white",
                                    position: "relative",
                                }}
                            >
                                {petImagePreview ? (
                                    <img
                                        src={petImagePreview}
                                        alt="預覽圖片"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: 250,
                                            marginBottom: 16,
                                            borderRadius: 8,
                                        }}
                                    />
                                ) : (
                                    <PlusSquare size={48} />
                                )}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            <Footer />
        </Box>
    );
};

export default CheckSupplierPage;
